import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/*
 * Bundler adds the complete kit itself. Forward its success notification to
 * the theme's native cart lifecycle; never submit the kit a second time.
 */
let requested = false;
let running = false;
let scheduled = false;

async function readJson(url) {
  const response = await fetch(url, {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Cart refresh failed: ' + response.status);
  return response.json();
}

async function refreshBundlerCart() {
  if (running) return;
  running = true;
  try {
    while (requested) {
      requested = false;
      const sectionIds = [...new Set(
        Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((component) => component.getAttribute('data-section-id'))
          .filter(Boolean)
      )].slice(0, 5);

      // The marker prevents Bundler from interpreting our read as another cart mutation.
      const cartUrl = new URL(Theme.routes.cart_url + '.js', window.location.origin);
      cartUrl.searchParams.set('bundler-cart-call', '1');
      const sectionsUrl = new URL(window.location.href);
      sectionsUrl.hash = '';
      sectionsUrl.searchParams.delete('section_id');
      sectionsUrl.searchParams.set('sections', sectionIds.join(','));
      sectionsUrl.searchParams.set('bundler-cart-call', '1');

      const [cart, sections] = await Promise.all([
        readJson(cartUrl.href),
        sectionIds.length ? readJson(sectionsUrl.href) : Promise.resolve({}),
      ]);
      if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count)) {
        throw new Error('Invalid cart response');
      }

      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [],
        promise: deferred.promise,
      }));
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          didError: false,
          source: 'fdm-bundler',
          sourceId: 'fdm-bundler',
          itemCount: cart.item_count,
          items: cart.items,
          sections: sections || {},
        },
      });
    }
  } catch (error) {
    console.warn('[Fil de Miel] Bundler cart refresh failed:', error);
    document.dispatchEvent(new CartErrorEvent({
      error: 'Votre kit a été ajouté. Actualisez la page pour afficher votre panier.',
      code: 'SERVICE_UNAVAILABLE',
    }));
  } finally {
    running = false;
    if (requested) scheduleRefresh();
  }
}

function scheduleRefresh() {
  requested = true;
  if (running || scheduled) return;
  scheduled = true;
  Promise.resolve().then(() => {
    scheduled = false;
    return refreshBundlerCart();
  });
}

document.addEventListener('bndlr:bundle_added_to_cart', scheduleRefresh);
